
import Error404 from '~/components/Error404';
import CampaignContribution from '~/components/resource/CampaignContribution';
import CampaignContributionLegal from './CampaignContributionLegal';
import Post from '~/components/resource/Post';

export default {
    name: 'Resource',
    created() {
        if (this.showCampaignContribution && this.campaign) {
            const lang = this.campaign.interfaceLanguage || this.campaign.profile.language;
            const languagePart = lang.split('-');
            this.$i18n.setLocale(languagePart[0]);
        }
    },
    components: { Post, Error404, CampaignContribution, CampaignContributionLegal },
    computed: {
        // main resource page data
        resource() {
            return this.$store.getters['resource/getByUrl'](this.$route.params.pathMatch);
        },
        showLoader() {
            return this.$store.getters['ui/getLoader'] === 'resource';
        },
        showPost() {
            return this.resource?.type === 'post' && this.post && !!this.post.audio;
        },
        showCampaignContribution() {
            return this.resource?.type === 'campaignContribution' && !this.$route.query?.legal;
        },
        showCampaignContributionLegal() {
            return this.resource?.type === 'campaignContribution' && this.$route.query?.legal;
        },
        show404() {
            if (this.showLoader) {
                return false;
            }

            if (this.post && !this.post.audio) {
                return true;
            }

            return this.resource == null;
        },
        post() {
            return this.resource.post;
        },
        campaign() {
            return this.resource.campaign;
        },
    },
};
